import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnInit,
  OnDestroy,
  ElementRef,
  Renderer2,
  Optional,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { RoleService } from '../services/role.service';

@Directive({
  selector: '[appHasPermission]',
  standalone: true,
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  @Input() appHasPermission: string | string[] = [];
  @Input() appHasPermissionMode: 'any' | 'all' = 'any';

  private subscription?: Subscription;

  constructor(
    @Optional() private templateRef: TemplateRef<any> | null,
    @Optional() private viewContainer: ViewContainerRef | null,
    @Optional() private elementRef: ElementRef | null,
    @Optional() private renderer: Renderer2 | null,
    private roleService: RoleService,
  ) {}

  ngOnInit(): void {
    const permissions = Array.isArray(this.appHasPermission)
      ? this.appHasPermission
      : [this.appHasPermission];

    const checkPermission$ =
      this.appHasPermissionMode === 'all'
        ? this.roleService.checkAllPermissions(permissions)
        : this.roleService.checkAnyPermission(permissions);

    this.subscription = checkPermission$
      .pipe(distinctUntilChanged())
      .subscribe((hasPermission) => {
        if (this.templateRef && this.viewContainer) {
          // Structural directive usage (*appHasPermission)
          if (hasPermission) {
            // Guard against duplicate renders when observable emits true multiple times
            if (this.viewContainer.length === 0) {
              this.viewContainer.createEmbeddedView(this.templateRef);
            }
          } else {
            this.viewContainer.clear();
          }
        } else if (this.elementRef && this.renderer) {
          // Attribute directive usage ([appHasPermission])
          if (hasPermission) {
            this.renderer.setStyle(
              this.elementRef.nativeElement,
              'display',
              '',
            );
          } else {
            this.renderer.setStyle(
              this.elementRef.nativeElement,
              'display',
              'none',
            );
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
